export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 1050,
  lg: 1280,
  xl: 1700,
}
